import React from "react";
export default function Chart({ signal }) {
  const candles = signal.velas?.slice(0, 15) || [];
  if (!candles.length)
    return signal.chart_url ? (
      <img className="chart" src={signal.chart_url} alt="Gráfico do sinal" />
    ) : (
      <div className="empty">Gráfico indisponível.</div>
    );
  const top = Math.max(...candles.map((c) => c.high)),
    bottom = Math.min(...candles.map((c) => c.low)),
    range = top - bottom || 1;
  const y = (n) => 25 + ((top - n) / range) * 130,
    x = (i) => 36 + i * 21.5;
  return (
    <svg
      className="chart"
      viewBox="0 0 370 185"
      role="img"
      aria-label={`Gráfico das últimas 15 velas de ${signal.ativo_display}`}
    >
      <rect width="370" height="185" rx="9" fill="#111526" />
      <text x="185" y="13" textAnchor="middle" fill="#ddd" fontSize="7">
        {signal.ativo_display} · {signal.direcao} (
        {signal.confirmacao.toFixed(1)}%) · {signal.timeframe}
      </text>
      {Array.from({ length: 5 }, (_, i) => (
        <g key={i}>
          <line
            x1="30"
            x2="355"
            y1={25 + i * 32.5}
            y2={25 + i * 32.5}
            stroke="#24283a"
            strokeWidth=".5"
          />
          <text
            x="26"
            y={27 + i * 32.5}
            textAnchor="end"
            fontSize="5"
            fill="#7c8291"
          >
            {(top - (range * i) / 4).toFixed(range < 1 ? 5 : 3)}
          </text>
        </g>
      ))}
      {candles.map((c, i) => {
        const color =
          c.close > c.open
            ? "#73df80"
            : c.close < c.open
              ? "#f15165"
              : "#9da6ac";
        return (
          <g key={c.from}>
            <line
              x1={x(i)}
              x2={x(i)}
              y1={y(c.high)}
              y2={y(c.low)}
              stroke={color}
              strokeWidth="1"
            />
            <rect
              x={x(i) - 6.3}
              y={Math.min(y(c.open), y(c.close))}
              width="12.6"
              height={Math.max(1, Math.abs(y(c.open) - y(c.close)))}
              fill={color}
            />
            <text
              x={x(i)}
              y="172"
              fill="#7c8291"
              fontSize="5"
              textAnchor="middle"
            >
              {i + 1}
            </text>
          </g>
        );
      })}
      <line
        x1="30"
        x2="355"
        y1={y(signal.preco_entrada)}
        y2={y(signal.preco_entrada)}
        stroke="#9fa8ff"
        strokeDasharray="3 2"
        strokeWidth=".6"
      />
      <text x="350" y="182" textAnchor="end" fill="#727b8e" fontSize="6">
        Velas capturadas · horário de Brasília
      </text>
    </svg>
  );
}
